export default {
  state: {
    slideList: []
  },
  mutations: {
    setSlideList(state, data) {
      state.slideList = [...data]
    }
  },
  actions: {

  },
  getters: {

  }
}
